export const parToDiagnoseParMapper = ({
  par,
  pathogens,
  symptoms,
  hidePatient,
  showDescriptionToPatient,
  patientImpactAtHome,
  trackingPointSide,
  impactionPointSide,
  patientComments,
  therapistComments,
}) => ({
  par: {
    id: par.id,
    name: par.name,
    description: par.description,
    type: { name: par.type.name },
    categories: par.categories,
    // Campos adicionais para permitír verificação reativa em isStepAddedIntoDiagnosis
    // sem depender de preload assíncrono (tipos Rastreio e Reservatório)
    typeId: par.typeId,
    trackingPointId: par.points?.trackingPoint?.id,
  },
  pathogens,
  symptoms,
  hidePatient,
  showDescriptionToPatient,
  patientImpactAtHome,
  trackingPointSide,
  impactionPointSide,
  patientComments,
  therapistComments,
});
